module.exports = __webpack_public_path__ + "img/room-customization.371b6dd6.png";